import {useCallback} from 'react';
import {twMerge} from '../../../common/twMerge';
import {PageNavigation} from '../PageNavigation/PageNavigation';

export function useRenderDots({
  hasIndicator,
  isMobile,
}: {
  hasIndicator: boolean;
  isMobile?: boolean;
}) {
  return useCallback(
    (curIdx: number, totalCount: number) => {
      if (!hasIndicator) {
        return null;
      }

      return (
        <div
          className={twMerge(
            'absolute z-10 m-0 flex justify-end pointer-events-none top-16pxr',
            // right-26pxr은, 배너 안쪽에 인디케이터가 있어서 15(배너 안쪽 위치)+11(배너바깥 간격)=26이 되었습니다.
            !isMobile && 'right-[calc(25%+17.5px)]',
            isMobile && 'right-27pxr foldable:right-[calc(20%+17.5px)]'
          )}
        >
          <PageNavigation idx={curIdx + 1} total={totalCount} />
        </div>
      );
    },
    [hasIndicator, isMobile]
  );
}
